import React, { Component } from 'react'

class ParkingDisplay extends Component {

    constructor(props){
        super(props)
        this.getPrioritiesOptions = this.getPrioritiesOptions.bind(this)
    }

    getPrioritiesOptions(parkings, selectedParkingId){
        var result = []
        for (var parkingId in parkings){
            if (parkings[parkingId].priority === undefined){
                continue
            }
            var option = `${parkings[parkingId].priority}. `
            if (parkingId === selectedParkingId){
                option += '(Prioridad actual)'
            }
            else {
                option += `(Intercambiar con ${parkings[parkingId].name})`
            }
            result.push(option)
        }
        result.sort()
        return result
    }


    render(){
        const {
            parkings,
            selectedParkingId,
            errorMessages,
            disabled,
            onNameChange,
            onCapacityChange,
            onPriorityChange
        } = this.props
        const {getPrioritiesOptions} = this
        const parking = parkings[selectedParkingId]
        const prioritiesOptions = getPrioritiesOptions(parkings, selectedParkingId)
        const actualPriority = prioritiesOptions.filter(el => el.startsWith(`${parking.priority}.`))
        return(
            <div className="guest-reservation-block">
                <div className="parking-display-box">
                    <table>
                        <tr>
                            <th className="table-left">Nombre</th>
                            <th className={errorMessages.invalidName ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={parking.name}
                                    disabled={disabled}
                                    onChange={onNameChange}
                                />
                            </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="table-left">Capacidad</th>
                            <th className={errorMessages.invalidCapacity ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <input
                                    type="text"
                                    className="text-input"
                                    value={parking.capacity}
                                    disabled={disabled}
                                    onChange={onCapacityChange}
                                />
                            </div>
                            </th>
                        </tr>
                        <tr>
                            <th className="table-left">Prioridad</th>
                            <th className={errorMessages.invalidPriority ? "input-error-container" : "input-block"}>
                            <div className="input-error">
                                <p>
                                  <select class="arrows" onChange={onPriorityChange} value={actualPriority[0]}>
                                  {
                                    prioritiesOptions.map(el => {
                                        return (
                                            <option value={el}>{el}</option>
                                        )
                                    })
                                  }
                                   </select>
                                </p>
                            </div>
                            </th>
                        </tr>
                    </table>
                </div>
            </div>
        )
    }

}
export default ParkingDisplay
